import { Icon } from '@dev-spendesk/grapes';
import { format } from 'ezmoney';

import { useTranslation } from 'common/hooks/useTranslation';
import { VerticalLine } from 'modules/requests/components/common/VerticalLine';

import styles from './StayResultOverview.module.css';

type Props = {
  stay: {
    propertyId: string;
    name: string;
    image: string;
    rating: {
      stars: number;
      reviewCount: number;
    };
    distance: number;
    price: {
      nightlyFrom: {
        amount: number;
        precision: number;
        currency: string;
      };
      totalFrom: {
        amount: number;
        precision: number;
        currency: string;
      };
    };
    fewRoomsLeft: boolean;
  };
  onSelect?: (propertyId: string) => void;
};

export function StayResultOverview({ stay, onSelect }: Props) {
  const { t } = useTranslation('global');

  return (
    <button
      type="button"
      onClick={() => onSelect?.(stay.propertyId)}
      className={styles.StayResultOverview}
    >
      <img
        src={stay.image}
        alt={stay.name}
        className="rounded-8 h-[200px] w-[200px] min-w-0 object-cover"
      />
      <div className="flex flex-1 flex-col items-start gap-4">
        <h3 className="title-xl">{stay.name}</h3>
        <div className="body-m flex items-center gap-4">
          <Icon name="star-filled" />
          {stay.rating.stars}
          <span>({stay.rating.reviewCount})</span>
          <VerticalLine className="text-content-disabled mx-8" height={14} />
          <Icon name="magnifying-glass" />
          <span>
            {t('travel.hotel.searchResult.distance', {
              distance: (stay.distance / 1000).toFixed(2),
            })}
          </span>
        </div>
        {stay.fewRoomsLeft && (
          <p className="body-m text-content-alert-default inline-flex items-center">
            <Icon name="triangle-warning" className="mr-4" />
            {t('travel.hotel.searchResult.fewRooms')}
          </p>
        )}
        <p className="body-m text-content-secondary-bg-primary mt-auto">
          {t('travel.hotel.searchResult.pricePerNight', {
            price: format(stay.price.nightlyFrom),
          })}
        </p>
        <p className="title-xl">{format(stay.price.totalFrom)}</p>
      </div>
    </button>
  );
}
